(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-megamenu"] && !Shopify.designMode) return;
  try {
    /* KJ-B2B : images des megamenus (loading="lazy", cachées en display:none) chargées et décodées
     dès que la page est au repos, ou au premier survol / focus du menu : l'ouverture est instantanée. */
  (function () {
    var done = false;
    function warm() {
      if (done) return;
      done = true;
      document.querySelectorAll('.header__submenu--megamenu img.kj-mm-img').forEach(function (img) {
        img.loading = 'eager';
        if (img.decode) img.decode().catch(function () {});
      });
    }
    function idle() {
      if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 });
      else setTimeout(warm, 1200);
    }
    /* préchargement au repos seulement sur ordinateur (sur mobile le megamenu n'existe pas : pas de données gaspillées) */
    var desktop = window.matchMedia && window.matchMedia('(min-width: 1000px) and (hover: hover)').matches;
    if (desktop) {
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
    }
    ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target.closest && e.target.closest('.header__menu-item--megamenu')) warm();
      }, { passive: true, capture: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kj-mon-espace"] && !Shopify.designMode) return;
  try {
    /* Mon espace pro : volets « Mes commandes » et « Mon compte » ouverts par les liens des cartes
     (#mes-commandes, #mon-compte, aussi à l'arrivée sur la page avec ce lien), détail d'une commande sous sa ligne. */
  if (!customElements.get('kj-mon-espace')) {
    customElements.define('kj-mon-espace', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const ouvrir = e.target.closest('[data-kj-ouvrir]');
          if (ouvrir) {
            e.preventDefault();
            this.ouvrir(ouvrir.dataset.kjOuvrir, ouvrir.dataset.kjCommande);
            return;
          }
          const fermer = e.target.closest('[data-kj-fermer]');
          if (fermer) {
            const v = fermer.closest('[data-kj-volet]');
            if (v) v.classList.remove('is-ouvert');
            if (window.location.hash === '#' + (v && v.id)) history.replaceState(null, '', window.location.pathname + window.location.search);
            return;
          }
          const b = e.target.closest('[data-voir]');
          if (b) this.basculer(b);
        });
        const h = window.location.hash.slice(1);
        if (h && this.querySelector('[data-kj-volet]#' + CSS.escape(h))) this.ouvrir(h, null, true);
      }
      ouvrir(id, commande, arrivee) {
        const v = this.querySelector('#' + CSS.escape(id));
        if (!v) return;
        v.classList.add('is-ouvert');
        let cible = v;
        if (commande) {
          const d = this.querySelector('#' + CSS.escape(commande));
          const b = this.querySelector('[data-voir][aria-controls="' + commande + '"]');
          if (d) {
            const repli = d.closest('details');
            if (repli) repli.open = true;
            if (b && b.getAttribute('aria-expanded') !== 'true') this.basculer(b);
            cible = b ? b.closest('[role="row"]') || v : v;
            cible.style.scrollMarginTop = '140px';
          }
        }
        if (!arrivee) history.replaceState(null, '', '#' + id);
        setTimeout(() => cible.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
      }
      basculer(b) {
        const p = document.getElementById(b.getAttribute('aria-controls'));
        if (!p) return;
        const ouvert = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!ouvert));
        b.textContent = ouvert ? b.dataset.texte : (b.dataset.texteMasquer || b.dataset.texte);
        p.hidden = ouvert;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kj-shop-text"] && !Shopify.designMode) return;
  try {
    /* Accordéon « un seul volet ouvert » (fiche produit, 2026-10-07).
     Posé via « Classe additionnelle » = kj-acc-single sur un bloc Accordéons natif.
     Le bloc natif rend des <details> indépendants : quand un volet s'ouvre, on referme les
     autres volets du même accordéon. Aucun fichier vendor modifié. */
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    var group = details.closest('.kj-acc-single');
    if (!group) return;
    group.querySelectorAll('details[open]').forEach(function (other) {
      if (other !== details && other.closest('.kj-acc-single') === group) other.open = false;
    });
  }, true);

  /* Toujours un volet ouvert : un clic sur le titre du volet déjà ouvert ne le referme pas. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    if (details.closest('.kj-acc-single')) event.preventDefault();
  }, true);
  } catch(e) { console.error(e); }
})();

})();
